export default {
  fulfillment_rate: "Fulfillment Rate",
  revenue: "Revenue",
  new_orders: "New Orders",
  expiring_today: "Expiring Today",

  sales: "Sales",
  orders: "Orders",
};